<template>
  <v-app id="inspire">
    <v-snackbar
      class="pb-16"
      v-model="esDesarrollo"
      color="warning"
      bottom
      left
      :timeout="0"
    >¡ Modo Prueba !</v-snackbar>

    <v-app-bar
      v-if="mostrarMenu()"
      :height="$vuetify.breakpoint.smAndDown ? '56' : '78'"
      class="index-4 px-0 px-md-4"
      :class="(webPropio.general && webPropio.general.fondoHeader) ? webPropio.general.fondoHeader : 'black'"
      :dark="(webPropio.general && webPropio.general.darkHeader) ? webPropio.general.darkHeader : false"
      :light="(webPropio.general && webPropio.general.darkHeader) ? !webPropio.general.darkHeader : true"
      app
      clipped-right
      elevate-on-scroll
    >
      <v-row>
        <v-col class="my-auto pa-0">
          <v-app-bar flat class="transparent">
            <v-app-bar-nav-icon class @click.stop="left = !left"></v-app-bar-nav-icon>
            <v-toolbar-title
              class="pa-0 ma-0 d-none d-sm-flex"
              @click="goHome"
              v-if="(webPropio.general && webPropio.general.logoIzquierda)"
            >
              <v-img
                class="pa-0 ml-4"
                :src="(webPropio.general && webPropio.general.logoIzquierda) ? webPropio.general.logoIzquierda : ''"
                :lazy-src="(webPropio.general && webPropio.general.logoIzquierda) ? webPropio.general.logoIzquierda : ''"
                contain
                :height="$vuetify.breakpoint.mdAndDown ? '25' : '34'"
                :width="$vuetify.breakpoint.mdAndDown ? '140' : '180'"
              ></v-img>
            </v-toolbar-title>
            <headerToolbarRestaurante
              class="ml-4 pa-0 align-center"
              v-if="esDomicilio && activeRestObj != null"
            />
          </v-app-bar>
        </v-col>
        <v-col cols="2" class="pa-0">
          <v-img
            style="left: 50%; position: absolute; transform: translateX(-50%); top: 0px;"
            @click="goHome"
            class="pa-0"
            :src="(webPropio.general && webPropio.general.logoCentro) ? webPropio.general.logoCentro : ''"
            :lazy-src="(webPropio.general && webPropio.general.logoCentro) ? webPropio.general.logoCentro : ''"
            contain
            max-height="118"
            :height="$vuetify.breakpoint.smAndDown ? '56' : 'auto'"
            :width="$vuetify.breakpoint.smAndDown ? '120' : 'auto'"
          ></v-img>
        </v-col>
        <v-col class="my-auto text-right pa-0">
          <v-app-bar flat class="transparent">
            <v-spacer />
            <!--la carta-->
            <v-btn
              class="hidden-sm-and-down mr-4 textTNone"
              style="max-width:200px"
              text
              @click.stop="navegarCarta"
            >
              <v-icon size="28" left>mdi-newspaper</v-icon>
              <span class="text-truncate" style="max-width:120px">La Carta</span>
            </v-btn>
            <!-- Menu Usuario  -->
            <cuentaMenuUser />

            <v-app-bar-nav-icon class @click.stop="cartDrawer = !cartDrawer">
              <v-badge color="amber accent-2 black--text" overlap bottom left>
                <template v-slot:badge>{{cantidad}}</template>
                <v-img
                  class
                  :src="(webPropio.general && webPropio.general.bolsaCarrito) ? webPropio.general.bolsaCarrito : ''"
                  :lazy-src="(webPropio.general && webPropio.general.bolsaCarrito) ? webPropio.general.bolsaCarrito : ''"
                  :width="$vuetify.breakpoint.mdAndDown ? '29' : '33'"
                  :height="$vuetify.breakpoint.mdAndDown ? '40' : '48'"
                ></v-img>
              </v-badge>
            </v-app-bar-nav-icon>
          </v-app-bar>
        </v-col>
        <!--
        <completaRegistro />-->
      </v-row>
    </v-app-bar>

    <!-- Menú movil -->
    <v-navigation-drawer
      :src="(webPropio.general && webPropio.general.fondoDrawerImagen) ? webPropio.general.fondoDrawerImagen : ''"
      :lazy-src="(webPropio.general && webPropio.general.fondoDrawerImagen) ? webPropio.general.fondoDrawerImagen : ''"
      :color="(webPropio.general && webPropio.general.fondoDrawer) ? webPropio.general.fondoDrawer : ''"
      :dark="(webPropio.general && webPropio.general.darkDrawer) ? webPropio.general.darkDrawer : false"
      :light="(webPropio.general && webPropio.general.darkDrawer) ? !webPropio.general.darkDrawer : false"
      v-model="left"
      fixed
      temporary
      touchless
    >
      <v-list-item
        :class="(webPropio.general && webPropio.general.colorMenuUser) ? webPropio.general.colorMenuUser : ''"
        v-if="user != null"
        :dark="(webPropio.general && webPropio.general.darkMenuUser) ? webPropio.general.darkMenuUser : false"
        :light="(webPropio.general && webPropio.general.darkMenuUser) ? !webPropio.general.darkMenuUser : false"
      >
        <v-list-item-avatar>
          <v-icon size="38">mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-subtitle>Hola,</v-list-item-subtitle>
          <v-list-item-title class="title">{{ (user) ? user.displayName : 'Anónimo'}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list>
        <v-list-item-group
          :dark="(webPropio.general && webPropio.general.darkMenuUser) ? webPropio.general.darkMenuUser : false"
          :light="(webPropio.general && webPropio.general.darkMenuUser) ? !webPropio.general.darkMenuUser : true"
          v-model="group"
          :active-class="(webPropio.general && webPropio.general.menuUserActivoClases) ? webPropio.general.menuUserActivoClases : ''"
        >
          <v-list-item
            v-for="link in linksScroll"
            :key="link.text"
            link
            @click="navegar( link.go )"
          >
            <v-list-item-icon>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ link.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-list-item @click="navegarCarta">
            <v-list-item-icon>
              <v-icon>mdi-newspaper</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>La Carta</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <v-divider></v-divider>

      <template v-slot:append>
        <div class="pa-2">
          <v-list>
            <v-list-item
              v-for="link in tuCuenta"
              :key="link.name"
              link
              @click="$router.push( link.path )"
            >
              <v-list-item-content>
                <v-list-item-title>{{ link.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-btn block>Logout</v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- Carritos productos-->
    <finalizarCarrito />
    <v-content>
      <router-view />

      <v-snackbar top v-model="snackbar" :color="snackbar_color">
        {{ snackbar_text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
        </template>
      </v-snackbar>
    </v-content>

    <!--dialogo reiniciar pedido-->
    <v-dialog v-model="continuarPedidoSnackbar" persistent max-width="600">
      <v-card class>
        <v-card-title class="title mb-2">Tienes un pedido ya comenzado, ¿Que prefiere hacer?</v-card-title>
        <v-card-text
          class="subtitle-1"
        >Tu pedido incluye artículos de {{$store.state.pedido.negocioObjPedido.nombre}} - {{$store.state.pedido.restauranteObjPedido.nombre}}. Vas empezar un nuevo pedido en {{$store.state.pedido.datosCompararNuevo.negocioObj.nombre}} - {{$store.state.pedido.datosCompararNuevo.restauranteObj.nombre}}</v-card-text>
        <v-card-actions class>
          <v-btn tile text color="info" @click.stop="continuarPedidoAnterior">Seleccionar anterior</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="px-8" tile color="success" @click.stop="comenzarNuevoPedido">Nuevo pedido</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="carritoComprobadoServidorCambiado" persistent max-width="600">
      <v-card class>
        <v-card-title class="title mb-2">Hay cambios en su carrito. ¿Quiere actualizarlo?</v-card-title>
        <v-card-text class="subtitle-1">
          <pedirCarritoContenido
            v-bind:opciones="{
                          select: false,
                          isResumen: false,
                          isComprobar: true,
                          totales: true
                        }"
          />
        </v-card-text>
        <v-card-actions class>
          <v-btn
            tile
            text
            color="info"
            @click.stop="carritoComprobadoServidorCambiado = false"
          >Lo haré manualmente</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="px-8"
            tile
            color="success"
            @click.stop="actualizarCarrito"
          >Actualizar carrito</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-footer
      :class="(webPropio.general && webPropio.general.colorFooter) ? webPropio.general.colorFooter : 'black'"
      :dark="(webPropio.general && webPropio.general.darkFooter) ? webPropio.general.darkFooter : false"
      :light="(webPropio.general && webPropio.general.darkFooter) ? !webPropio.general.darkFooter : true"
      v-if="mostrarMenu()"
    >
      <v-row>
        <v-col cols="12" md="auto" class="pa-0 my-auto text-center">
          <v-btn
            v-if="webPropio.general && webPropio.general.redesSociales && webPropio.general.redesSociales.facebook"
            class="mx-2"
            icon
            :href="webPropio.general.redesSociales.facebook"
            target="blank"
          >
            <v-icon size="24px">fab fa-facebook</v-icon>
          </v-btn>
          <v-btn
            v-if="webPropio.general && webPropio.general.redesSociales && webPropio.general.redesSociales.twitter"
            class="mx-2"
            icon
            :href="webPropio.general.redesSociales.twitter"
            target="blank"
          >
            <v-icon size="24px">fab fa-twitter</v-icon>
          </v-btn>
          <v-btn
            v-if="webPropio.general && webPropio.general.redesSociales && webPropio.general.redesSociales.instagram"
            class="mx-2"
            icon
            :href="webPropio.general.redesSociales.instagram"
            target="blank"
          >
            <v-icon size="24px">fab fa-instagram</v-icon>
          </v-btn>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" md="auto" class="pa-1 px-2 my-auto text-center">
          <v-btn
            text
            small
            class="caption"
            @click="$router.push('/terminos-y-condiciones-de-uso')"
          >Términos y condiciones</v-btn>

          <v-btn
            text
            small
            class="caption"
            @click="$router.push('/politica-de-cookies')"
          >Política de cookies</v-btn>
        </v-col>
        <v-col cols="12" md="auto" class="pa-1 px-2 my-auto text-center">
          © {{ new Date().getFullYear() }} —
          <strong
            class="ml-1"
          >{{(webPropio.general && webPropio.general.nombreFooter) ? webPropio.general.nombreFooter : '' }}</strong>
        </v-col>
      </v-row>
    </v-footer>
    <DialogoSoporte />
    <cookie-law theme="dark-lime" buttonText="¡OK!">
      <div slot="message">
        Este sitio web usa cookies para mejorar la experiencia de usuario. Puedes leer más en nuestra
        <router-link to="/politica-de-cookies">
          <span class="white--text">Política de Cookies</span>
        </router-link>
      </div>
    </cookie-law>
  </v-app>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import pedirCarritoContenido from "@/components/Pedidos/pedir_carrito_contenido.vue";
import headerToolbarRestaurante from "@/components/Pedidos/pedir_toolbarRestaurante.vue";
import cuentaMenuUser from "@/components/TuCuenta/tuCuenta_menuUser.vue";
import completaRegistro from "@/components/TuCuenta/tuCuenta_completaRegistro.vue";
import finalizarCarrito from "@/components/Pedidos/pedir_carritoLateral.vue";
import CookieLaw from "vue-cookie-law";

import DialogoSoporte from "@/components/DialogoSoporte.vue";

import { restSinNegocio } from "@/utils/restaurantes.utils.js";

export default {
  props: {
    source: String
  },
  watch: {
    group() {
      this.left = false;
    },
    $route(to, from) {
      //Cargar condiciones especiales por negocio
      this.cargarCondicionesEspecialesPorNegocio(to.path);
    }
  },
  components: {
    DialogoSoporte,
    headerToolbarRestaurante,
    cuentaMenuUser,
    finalizarCarrito,
    pedirCarritoContenido,
    CookieLaw,
    completaRegistro
  },
  data: () => ({
    items: [], //menu
    itemsLogueado: [], //menu logueado,
    tuCuenta: [],
    condicionPadthaiwok: false,
    tuCuenta: [],
    drawer: false,
    left: false,
    group: null,
    linksScroll: [
      /*
        text: "Franquicia",
        go: "#franquicia",
        icon: "mdi-handshake"
      },*/
      {
        text: "Contacto",
        go: "#contact",
        icon: "mdi-email-send-outline"
      }
    ]
  }),
  metaInfo() {
    return {
      //title: ,
      titleTemplate: this.webPropio.general.seo.titleTemplate,
      meta: [
        //{ name: "description", content: "Cervecería el pikoteo" },
        {
          property: "og:title"
          //content: "Cervecería el Pikoteo"
        },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" }
      ]
    };
  },
  computed: {
    carritoComprobadoServidorCambiado: {
      get() {
        return this.$store.state.pedido.carritoComprobadoServidorCambiado;
      },
      set(v) {
        this.$store.commit("pedido/setCarritoComprobadoServidorCambiado", v);
      }
    },
    snackbar: {
      get() {
        return this.$store.state.snackbar.show;
      },
      set(value) {
        this.$store.commit("snackbar/reset");
      }
    },
    continuarPedidoSnackbar: {
      get() {
        return this.$store.getters["pedido/continuarPedidoBool"];
      },
      set(value) {
        this.$store.commit("pedido/setContinuarPedido", false);
      }
    },
    ...mapState({
      // arrow functions can make the code very succinct!
      carritoComprobadoServidor: state =>
        state.pedido.carritoComprobadoServidor,
      webPropio: state => state.propio.negocioPropioObj.web,
      pedidoPendiente: state => state.pedido.pedidoPendiente,
      dialog: state => state.pedido.continuePedido,
      snackbar_text: state => state.snackbar.text,
      snackbar_color: state => state.snackbar.color,
      logged: state => state.auth.isLogged,
      user: state => state.auth.user,
      activeRestObj: state => state.pedido.restauranteObjPedido,
      direcciones: state => state.direcciones.dirPidiendo,
      title: state => state.app.titlePage,
      productos: state => state.restaurante.prodActiveCat.productos,
      carrito: state => state.pedido.carrito.productos,
      loadingCarrito: state => state.pedido.loadingCarrito,
      cantidad: state => state.pedido.carrito.numero_producto,
      precio: state => state.pedido.carrito.precio_total,
      loadingQuantity: state => state.pedido.loadingQuantity,
      negocioPropio: state => state.propio.negocioPropio
    }),
    ...mapGetters({
      //cantidad: 'pedido/precioPedido'
      esDomicilio: "pedido/esDomicilio",
      esDesarrollo: "app/esDesarrollo"
    }),
    isMobile: {
      get() {
        return this.$store.state.app.isMobile;
      },
      set(v) {
        this.$store.commit("app/setIsMobile", v);
      }
    },
    isSafari: {
      get() {
        return this.$store.state.app.isSafari;
      },
      set(v) {
        this.$store.commit("app/setIsSafari", v);
      }
    },
    alturaDinamicaHeader() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 56;
      } else {
        return 78;
      }
    },
    alturaDinamicaLogo() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 68;
      } else {
        return 118;
      }
    },
    alturaDinamicaLogoText() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 28;
      } else {
        return 34;
      }
    },
    cartDrawer: {
      get() {
        return this.$store.state.app.cartDrawer;
      },
      set(value) {
        this.$store.commit("app/setCartDrawer", value);
      }
    },
    cantidadConX: function(data) {
      return data + "x";
    },
    nombre() {
      return this.negocioObj ? this.negocioObj.nombre : "Sin nombre";
    }
  },
  methods: {
    goHome() {
      if (this.$route.path == "/") {
        this.$vuetify.goTo(0);
      } else {
        this.$router.push("/");
      }
    },
    navegarCarta() {
      if (this.$store.state.restaurante.listadoRestaurantes.length == 1) {
        this.$router.push(
          "/carta/" +
            restSinNegocio(this.$store.state.restaurante.listadoRestaurantes[0])
        );
      } else {
        this.$router.push(
          "/carta/" +
            restSinNegocio(this.$store.state.restaurante.listadoRestaurantes[0])
        );
      }
    },
    actualizarCarrito() {
      this.$store.commit(
        "pedido/setCarrito",
        this.$store.state.pedido.carritoComprobadoServidor
      );
      this.$store.dispatch("app/cerrarModales");
    },
    continuarPedidoAnterior() {
      //this.$store.commit("pedido/pedidoPendienteToEnCurso");
      this.$store.dispatch("pedido/navegarPagePedido");
    },
    comenzarNuevoPedido() {
      this.$store.commit("pedido/resetCarrito");
      this.$store.commit("pedido/resetPedidoPendiente");
      this.$store.commit("pedido/pedidoCompararToEnCurso");
      this.$store.dispatch("pedido/navegarPagePedido");
    },
    ...mapActions({
      localStorageLoad: "pedido/localStorageLoad"
    }),
    navegar(link) {
      let _vue = this;
      let duration = _vue.isSafari ? 0 : 500;
      let offset = _vue.$vuetify.breakpoint.smAndDown ? 50 : 0;
      this.left = false;

      if (this.$router.currentRoute.path == "/") {
        _vue.$vuetify.goTo(link, {
          duration: duration,
          offset: offset,
          easing: "easeOutQuad"
        });
      } else {
        _vue.$router.push("/").then(function() {
          _vue.$vuetify.goTo(link, {
            duration: duration,
            offset: offset,
            easing: "easeOutQuad"
          });
        });
      }
    },
    goPedir() {
      this.$router.push("/pedir");
    },
    saveEmail() {
      let _vm = this;
      this.loadingEmail = true;
      this.$store
        .dispatch("auth/savePerfil", {
          email: this.email
        })
        .then(function(r) {
          _vm.$store.commit("snackbar/setMensajeInfo", {
            msj: "Revisa tu correo y confirma tu email. Gracias!"
          });
        })
        .catch(e => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al actualizar el email: " + e
          });
        })
        .finally(function() {
          _vm.loadingEmail = false;
        });
    },
    enviarEmail() {
      let _vm = this;
      this.$store
        .dispatch("auth/sendEmail")
        .then(() => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Email enviado. Revisa tu correo"
          });
        })
        .catch(e => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al actualizar el perfil: " + e
          });
        });
    },
    comprobarPedido() {
      this.$store.dispatch("pedido/comprobarPedido");
    },
    logout() {
      let _vm = this;
      this.$store.dispatch("auth/firebaseLogout").then(r => {
        _vm.$router.push({
          path: "/"
        });
      });
    },
    comenzar() {
      let vue = this;
      //vue.$store.dispatch('pedido/resetPedido');
      this.$store.dispatch("pedido/removePedidoPendiente").then(function() {
        vue.$store.dispatch("pedido/resetPedido");
        vue.$router.push({
          path: "/pedir"
        });
      });
    },
    continuar() {
      this.$store.dispatch("pedido/navegarPagePedido");
      this.$store.commit("pedido/resetContinuePedido");
    },
    orientationEvent: function() {
      let _vue = this;
      window.addEventListener("orientationchange", function() {
        _vue.$store.commit(
          "app/setWindowOrientation",
          screen.orientation.angle
        );
        this.isTablet();
        this.isMobile();
      });
    },
    isTablet: function() {
      let _vue = this;
      let orientation =
        screen.orientation != undefined ? screen.orientation.type : "";

      let limits = orientation.includes("landscape")
        ? _vue.$vuetify.breakpoint.xs ||
          _vue.$vuetify.breakpoint.sm ||
          _vue.$vuetify.breakpoint.md
        : _vue.$vuetify.breakpoint.sm || _vue.$vuetify.breakpoint.xs;

      _vue.$store.commit("app/setIsTablet", limits);
    },
    isMobile: function() {
      let _vue = this;
      let orientation =
        screen.orientation != undefined ? screen.orientation.type : "";

      let limits = orientation.includes("landscape")
        ? _vue.$vuetify.breakpoint.xs || _vue.$vuetify.breakpoint.sm
        : _vue.$vuetify.breakpoint.xs;

      _vue.$store.commit("app/setIsMobile", limits);
    },
    setSafari: function() {
      let _vue = this;
      this.isSafari = /^((?!chrome|android).)*safari/i.test(
        navigator.userAgent
      );
    },
    mostrarMenu: function() {
      return !window.location.href.includes("/finalizar");
    },
    cargarCondicionesEspecialesPorNegocio: function(path) {
      let _vue = this;
      let val = path ? path : this.$router.currentRoute.path;

      switch (this.negocioPropio) {
        case "padthaiwok":
          _vue.condicionPadthaiwok = true;
          break;
      }
    },
    cambiarFavicon() {
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      let favicon =
        this.webPropio.general &&
        this.webPropio.general.favicon &&
        this.webPropio.general.favicon.length > 0
          ? this.webPropio.general.favicon
          : "http://mewosystems.com/img/favicon.png";
      link.href = favicon;
      document.getElementsByTagName("head")[0].appendChild(link);
    }
  },

  mounted() {
    //construimos drawer laterral de usuario
    const menuChildren = this.$router.options.routes[0].children;
    const basePath = "/";
    console.log(menuChildren);
    menuChildren.forEach(route => {
      let added = false;
      if (route.meta && route.meta.tucuenta) {
        this.tuCuenta.push({
          name: route.name,
          path: basePath + route.path
        });
        added = true;
      }
      if (route.meta && route.meta.superior) {
        if (route.meta.onlyAnonimous) {
          this.items.push({
            name: route.name,
            path: route.path
          });
          added = true;
        }
        if (route.meta.logged) {
          this.itemsLogueado.push({
            name: route.name,
            path: route.path
          });
          added = true;
        }
        if (!added) {
          this.itemsLogueado.push({
            name: route.name,
            path: route.path
          });
          this.items.push({
            name: route.name,
            path: route.path
          });
        }
      }
    });
    let _vm = this;
    //_vm.$store.commit("app/setLoading", true);
    this.$store.commit("app/setModoGeneral", "propio");
    this.cambiarFavicon();
    Promise.all([
      /** primera promesa, carga datos locales */
      this.localStorageLoad().then(() => {
        this.$store.commit("pedido/pedidoPendienteToEnCurso");
        this.$store.commit("pedido/setContinuarPedido", false);
      }),
      /** segunda promesa, carga negocio y restaurantes */
      this.$store
        .dispatch("propio/getNegocioPropio")
        .then(r => {
          return this.$store.dispatch("propio/getListadoRestaurantes");
        })
        .catch(e => {
          console.log(e);
          alert("Error en la carga inicial, recarge la página por favor");
          this.$router.push("/");
        })
    ]).then(() => {
      this.$store.commit("app/setCargadoComponenteApp", true);
      _vm.cambiarFavicon();
    });

    this.orientationEvent();
    this.isTablet();
    this.isMobile();
    this.setSafari();
  }
};
</script>

<style scoped>
.border {
  border: 1px solid #000;
}
.borderB {
  border: 1px solid #fff;
}
.index-4 {
  z-index: 4 !important;
}
</style>